import React from 'react';
import Paper from '@material-ui/core/Paper';

export default () => (
  <Paper
    style={{
      width: '80%',
      minHeight: '100px',
      margin: '0 auto',
      fontSize: '30px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
    elevation={1}
  >
    You are not authorized to view this resource
  </Paper>
);



// WEBPACK FOOTER //
// ./src/components/not-authorized/not-authorized.js